import { render } from "./drag-drop.vue?vue&type=template&id=2f46044b"
import script from "./drag-drop.vue?vue&type=script&lang=js"
export * from "./drag-drop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__